// extracted by mini-css-extract-plugin
module.exports = {"content":"RichContent-module--content--UpIA-"};